// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ab07862","667":"36692572","977":"ffd9bc24"}[chunkId] + ".chunk.js";
};